var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.738,
    height: 23.008,
    viewBox: "0 0 24.738 23.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(1164.841 -713.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M-1159.829,721.988h5.067l11.086-4.543-.537-1.311a1.375,1.375,0,0,0-1.794-.751l-16.979,6.959a1.375,1.375,0,0,0-.751,1.794l.537,1.311,1.61-.66V723.75A1.764,1.764,0,0,1-1159.829,721.988Z",
    transform: "translate(-1 -2)",
    fill: "#31b72d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M-1122.636,1047.4v-2.293l-.8.33Z",
    transform: "translate(-39.954 -320.024)",
    fill: "#31b72d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M-746.273,833.276l-1.057-2.579-6.292,2.579Z",
    transform: "translate(-396.54 -113.288)",
    fill: "#31b72d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M-1070.432,913.563h-18.35a1.376,1.376,0,0,0-1.376,1.375V926.1a1.376,1.376,0,0,0,1.376,1.375h18.35a1.375,1.375,0,0,0,1.375-1.375V914.938A1.375,1.375,0,0,0-1070.432,913.563Zm-13.8,5.323a.58.58,0,0,1-.58.58H-1088a.579.579,0,0,1-.58-.58v-2.145a.579.579,0,0,1,.58-.58h3.188a.58.58,0,0,1,.58.58Z",
    transform: "translate(-71.046 -191.188)",
    fill: "#31b72d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/cards.icon.57d26dbf1057e679fe26edca6e5462a3.svg";
export { ForwardRef as ReactComponent };